<template>
  <nav :class="['nav', isActive ? 'nav--active' : '']">
    <nuxt-link :to="'/'">
      <img v-if="logo" class="nav__logo" :src="logo" />
    </nuxt-link>
    <BaseToggler @toggleMenu="onToggleClick" />
    <MenuList :links="links" :modificatorClass="'menu--header'" />
    <BaseBtn
      v-if="!loggedIn"
      customClass="login"
      :class="!registrationEnabled ? 'btn--disabled' : ''"
      text="Увійти"
      @click.prevent.native="openModal"
    />
    <BaseBtn v-if="loggedIn" :customClass="'cabinet'" :to="'user'" />
    <BaseModal :opened="isOpened" @close="isOpened = false">
      <template slot="body">
        <AppModalWrapper />
      </template>
    </BaseModal>
    <BaseOverlay />
  </nav>
</template>

<script>
import { EventBus } from '~/plugins/eventBus'
import { mapGetters } from 'vuex'
import MenuList from '~/components/MenuList'
import AppModalWrapper from '~/components/modals/AppModalWrapper'

export default {
  name: 'TheNavbar',
  data() {
    return {
      isActive: false,
      isOpened: false,
      logo: undefined
    }
  },
  components: {
    MenuList,
    AppModalWrapper
  },
  async beforeCreate() {
    const { data } = await this.$axios.get('/header')
    this.logo = data.logo
  },
  computed: {
    links() {
      return this.messages.global.header.nav
    },
    registrationEnabled() {
      return this.messages.global.registrationEnabled
    },
    ...mapGetters({
      loggedIn: 'auth/loggedIn',
      openedModal: 'common/openedModal'
    })
  },
  methods: {
    onToggleClick() {
      this.isActive = !this.isActive
    },
    openModal() {
      if (this.registrationEnabled) {
        this.isOpened = !this.isOpened
      }
    }
  },
  mounted() {
    EventBus.$on('menuLinkClicked', () => {
      this.isActive = false
    })
  }
}
</script>

<style lang="scss">
.nav {
  flex-grow: 1;
  display: flex;
  justify-content: space-between;
  align-items: center;

  &--active {
    .menu {
      position: fixed;
      z-index: 5;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      margin-bottom: 0;
      padding: 20px 16px 20px 16px;
      background-color: rgb(243, 242, 243);
    }

    .nav__toggler {
      position: fixed;
      z-index: 10;

      span {
        &:nth-of-type(1) {
          transform: rotate(45deg) translate(5px, 5px);
        }

        &:nth-of-type(2) {
          opacity: 0;
        }

        &:nth-of-type(3) {
          transform: rotate(-45deg) translate(5px, -5px);
        }
      }
    }
  }

  &__logo {
    width: 54px;
    height: 48px;
  }

  &__toggler {
    @include button-reset;
    @include easeOut;

    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    cursor: pointer;

    span {
      @include easeOut;

      position: relative;
      display: block;
      width: 20px;
      height: 2px;
      background-color: #e8152a;
      opacity: 1;

      &:not(:last-of-type) {
        margin-bottom: 5px;
      }
    }
  }
}

@include media-min($tablet-width) {
  .nav {
    &__toggler {
      @include element-invisible;
    }
  }
}

@include media-min($desktop-width) {
  .nav {
    &__logo {
      width: 70px;
      height: 68px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// components/TheHeader/TheNavbar.vue